import React from 'react';
import { gql } from '@apollo/client';
import { Stack, Text } from '@moda/om';
import { isDiscounted } from '../../lib/variantUtils/isDiscounted';
import { ColorSwitcherDescriptionVariantFragment } from '../../generated/types';
import { normalizeColorName } from '../../lib/normalizeColorName';

export const COLOR_SWITCHER_DESCRIPTION_VARIANT_FRAGMENT = gql`
  fragment ColorSwitcherDescriptionVariantFragment on VariantData {
    color
    customColorName: custom_color_name
    soldOut: sold_out
    prices(country_code: $countryCode) {
      originalPrice: original_price {
        price
      }
      currentPrice: current_price {
        price
      }
    }
  }
`;

interface Props {
  colorDetailsVariant: ColorSwitcherDescriptionVariantFragment;
}
export const ColorSwitcherDescription: React.FC<Props> = ({ colorDetailsVariant }) => {
  return (
    <Stack space={2} direction="horizontal" className="ColorSwitcherDescription">
      <Text>Color</Text>
      <Text>—</Text>
      <Text>
        {normalizeColorName(colorDetailsVariant.customColorName || colorDetailsVariant.color)}
      </Text>
      {colorDetailsVariant.soldOut && (
        <>
          <Text>—</Text>
          <Text color="code-red">Sold Out</Text>
        </>
      )}
      {!colorDetailsVariant.soldOut && isDiscounted(colorDetailsVariant.prices) && (
        <>
          <Text>—</Text>
          <Text color="code-red">Sale</Text>
        </>
      )}
    </Stack>
  );
};
